export default {
  mounted(el, binding) {
    const startedInside = { value: false }

    el.pointerDownEvent = (event) => {
      const path = event.composedPath?.()
      startedInside.value = path ? path.includes(el) : el.contains(event.target)
    }

    el.clickOutsideEvent = (event) => {
      const path = event.composedPath?.()
      const clickedInside = path ? path.includes(el) : el.contains(event.target)
      const interactionStartedInside = startedInside.value

      startedInside.value = false

      if (!clickedInside && !interactionStartedInside) {
        binding.value(event, el)
      }
    }

    document.body.addEventListener('pointerdown', el.pointerDownEvent, true)
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unmounted(el) {
    document.body.removeEventListener('pointerdown', el.pointerDownEvent, true)
    document.body.removeEventListener('click', el.clickOutsideEvent)
  },
}
